import axios from 'axios'
import { configure, makeUseAxios } from 'axios-hooks'
import { baseURL } from '../../server/common/constants/Network'

export const axiosPrivate = axios.create({
	baseURL
})

// Token refresh configuration
const TOKEN_REFRESH_INTERVAL = 10 * 60 * 1000 // Refresh token every 10 minutes of activity
let lastTokenRefresh = Date.now()
let isRefreshing = false

// Function to refresh the token
const refreshToken = async () => {
	if (isRefreshing) return

	const token = localStorage.getItem('accessToken')
	if (!token) return

	isRefreshing = true
	try {
		const response = await axiosPrivate.post(`/auth/refresh-token`, {}, { headers: { 'x-access-token': token } })

		if (response.data?.accessToken) {
			localStorage.setItem('accessToken', response.data.accessToken)
			lastTokenRefresh = Date.now()
		}
	} catch (error) {
		// If refresh fails with 401, user will be logged out by response interceptor
		console.error('Token refresh failed:', error)
	} finally {
		isRefreshing = false
	}
}

// request interceptor to add token to request headers
axiosPrivate.interceptors.request.use(
	async (config) => {
		const token = localStorage.getItem('accessToken')

		if (token) {
			config.headers = {
				'x-access-token': token
			}

			// Check if we should refresh the token (every 10 minutes of activity)
			// Don't refresh on the refresh-token endpoint itself to avoid loops
			if (!config.url?.includes('/api/auth/refresh-token') && Date.now() - lastTokenRefresh > TOKEN_REFRESH_INTERVAL) {
				await refreshToken()
			}
		}
		return config
	},
	(error) => Promise.reject(error)
)

axiosPrivate.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			localStorage.removeItem('accessToken')
			window.location = '/'
		}

		if (axios.isCancel(error)) {
			return Promise.reject()
		}

		const reason = { message: 'Something went wrong!', status: error.response?.status, response: error.response }

		if (error.response?.data?.message) {
			reason.message = error.response.data.message
		}

		return Promise.reject(reason)
	}
)

configure({ axios: axiosPrivate })

const axiosPublic = axios.create({
	baseURL
})

axiosPublic.interceptors.response.use(
	(response) => response,
	(error) => Promise.reject((error.response && error.response.data) || 'Something went wrong!')
)

export default axiosPublic

export const useAxiosPublic = makeUseAxios({
	axios: axiosPublic
})

export const getErrorMsgBeOr = (error, msg) => {
	return error?.message || msg
}
